import React, { useState } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

import { Pie } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const TicketStatusComponent = ({ ticket_statuses }: any) => {
    const [displayClosedTickets, setDisplayClosedTickets] = useState(false);

    // Filter ticket statuses based on the checkbox state
    const filteredStatuses = displayClosedTickets
        ? ticket_statuses // Include all statuses
        : ticket_statuses.filter((status: any) => status.status_name !== "CLOSED"); // Exclude "CLOSED"

    // Labels and data for the Pie chart
    const labels = filteredStatuses.map((status: any) => status.status_name);
    const dataCounts = filteredStatuses.map((status: any) => status.count);
    const options = {
        maintainAspectRatio: false,
    };

    const data = {
        labels, // Status names
        datasets: [
            {
                data: dataCounts, // Status counts
                backgroundColor: ['#FBBF24', '#3B82F6', '#EC4899', '#8B5CF6', '#22D3EE', '#FF4500', '#32CD32', '#6A5ACD'],
                hoverOffset: 4,
            },
        ],
    };

    // Handle checkbox toggle
    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDisplayClosedTickets(e.target.checked);
    };

    return (
        <div className="p-4 border border-border rounded-lg shadow-md">
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold">Ticket Status</h3>
                <div className="flex items-center space-x-2">
                    <input
                        type="checkbox"
                        id="displayClosedTickets"
                        checked={displayClosedTickets}
                        onChange={handleCheckboxChange}
                        className="form-checkbox"
                    />
                    <label htmlFor="displayClosedTickets" className="text-sm font-medium">
                        Display closed tickets
                    </label>
                </div>
            </div>
            <div className="flex flex-col md:flex-row">
                {/* Chart Section */}
                <div className="flex-shrink-0 w-full md:w-1/2">
                    <Pie className="h-100" data={data} options={options} />
                </div>
                {/* Table Section */}
                <div className="flex-1 mt-4 md:mt-0 md:ml-4 mr-4">
                    <table className="w-full text-left border-collapse">
                        <thead>
                            <tr>
                                <th className="py-2 border-b border-border">Status</th>
                                <th className="py-2 border-b border-border text-right">Number</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredStatuses.map((item: any, index: any) => (
                                <tr key={index}>
                                    <td className="py-2">{item.status_name}</td>
                                    <td className="py-2 text-right">{item.count}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default TicketStatusComponent;

